import React from 'react';
import { Box, Typography } from '@mui/material';

const MobileListDetailRow = ({ label, value }) => {
	if (!value) {
		return null;
	}

	return (
		<Box>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', lineHeight: 1.2 }}
			>
				{label}
			</Typography>
			<Typography variant="body2" sx={{ wordBreak: 'break-word', mt: 0.15 }}>
				{value}
			</Typography>
		</Box>
	);
};

export default MobileListDetailRow;
